import { IOrderAddUpdateList } from "interfaces/Index";
import { normalizeProductCityLevelSearchResult } from "normalizer/GlobalProductNormalizer";
import { fetchProductCityLevelsApiCall } from "redux/sources/ProductCityLevelSource";
import { removeArrayOfObjectDuplicates } from "utils/lib";

export const doProductAPIsearch = async (
  cityId: string,
  val: any,
  setProductData: any,
  setProductLoading: any,
  selectedProducts: any,
  productSequenceProducts: any
) => {
  setProductLoading(true);
  let productData: any = await fetchProductCityLevelsApiCall(cityId, {
    searchKey: val,
    size: "25",
    sortColumn: "title",
    sortDirection: "ASC",
  });
  if (productData && productData.productCityLevelData) {
    let normalizedProducts: Array<IOrderAddUpdateList> =
      normalizeProductCityLevelSearchResult(productData.productCityLevelData);
    if (selectedProducts.length > 0) {
      normalizedProducts = removeArrayOfObjectDuplicates(
        normalizedProducts,
        selectedProducts,
        "id"
      );
    }
    if (productSequenceProducts.length > 0) {
      normalizedProducts = removeArrayOfObjectDuplicates(
        normalizedProducts,
        productSequenceProducts,
        "id"
      );
    }
    setProductData(normalizedProducts);
    setProductLoading(false);
  }
};
